import { Navigate } from 'react-router-dom';
import AuthGuard from '../auth/AuthGuard';
import AuthAdminGuard from '../auth/AuthAdminGuard';
import { PATH_ADMIN_DASHBOARD } from './paths';
import {
  AdminDashboardLayout,
  AdminDashboardPage,
  AdminProductListPage,
  AdminProductsubListPage,
  AdminSubscriptionListPage,
  AdminCouponListPage,
  AdminHorseListPageDashboard,
  AdminHorseOwnershipListPageDashboard,
  AdminHorseOwnershipPendingListPageDashboard,
  AdminWorkoutHorseListPage,
  AdminSingleWorkoutViewPage,
  AdminTrackListPage,
  AdminCreateTrackPage,
  AdminMetaStriderListPage,
  AdminUserListPage,
  AdminNotificationPage,
  AdminPromoListPage,
  AdminCreatePromoPage,
  AdminDatabaseManagerPage,
  AddHorsePage,
  UserAccountPage,
  MyOrdersPage,
  HorseEditPage,
} from './elements';

export const adminRoutes = {
  path: 'admin',
  element: (
    <AuthGuard>
      <AuthAdminGuard>
        <AdminDashboardLayout />
      </AuthAdminGuard>
    </AuthGuard>
  ),
  children: [
    { element: <Navigate to="/admin/app" replace />, index: true },
    { path: 'app', element: <AdminDashboardPage /> },
    { path: PATH_ADMIN_DASHBOARD.product.list, element: <AdminProductListPage /> },
    { path: PATH_ADMIN_DASHBOARD.subscription.list, element: <AdminProductsubListPage /> },
    { path: PATH_ADMIN_DASHBOARD.order.list, element: <MyOrdersPage /> },
    { path: PATH_ADMIN_DASHBOARD.coupon.list, element: <AdminCouponListPage /> },
    { path: PATH_ADMIN_DASHBOARD.metastrider.list, element: <AdminMetaStriderListPage /> },
    {
      path: 'horse',
      children: [
        { element: <Navigate to="/admin/horse" replace />, index: true },
        { path: PATH_ADMIN_DASHBOARD.horse.list, element: <AdminHorseListPageDashboard /> },
        { path: PATH_ADMIN_DASHBOARD.horse.create, element: <AddHorsePage /> },
        { path: PATH_ADMIN_DASHBOARD.horse.edit, element: <HorseEditPage /> },
        {
          path: PATH_ADMIN_DASHBOARD.horse.ownerships_approved,
          element: <AdminHorseOwnershipListPageDashboard />,
        },
        {
          path: PATH_ADMIN_DASHBOARD.horse.ownerships_pending,
          element: <AdminHorseOwnershipPendingListPageDashboard />,
        },
      ],
    },
    {
      path: 'workout',
      children: [
        { element: <Navigate to="/admin/workout" replace />, index: true },
        { path: PATH_ADMIN_DASHBOARD.workout.list, element: <AdminWorkoutHorseListPage /> },
        {
          path: PATH_ADMIN_DASHBOARD.workout.details,
          element: <AdminSingleWorkoutViewPage />,
        },
        {
          path: `${PATH_ADMIN_DASHBOARD.workout.workout_details}/:workoutId`,
          element: <AdminSingleWorkoutViewPage />,
        },
      ],
    },
    {
      path: 'track',
      children: [
        { element: <Navigate to="/admin/track" replace />, index: true },
        { path: PATH_ADMIN_DASHBOARD.track.list, element: <AdminTrackListPage /> },
        { path: PATH_ADMIN_DASHBOARD.track.create, element: <AdminCreateTrackPage /> },
      ],
    },
    {
      path: 'promo',
      children: [
        { element: <Navigate to="/admin/promo" replace />, index: true },
        { path: PATH_ADMIN_DASHBOARD.promo.list, element: <AdminPromoListPage /> },
        { path: PATH_ADMIN_DASHBOARD.promo.create, element: <AdminCreatePromoPage /> },
      ],
    },
    {
      path: 'user',
      children: [
        { element: <Navigate to={PATH_ADMIN_DASHBOARD.user.list} replace />, index: true },
        { path: 'account', element: <UserAccountPage /> },
        { path: PATH_ADMIN_DASHBOARD.user.list, element: <AdminUserListPage /> },
      ],
    },
    { path: PATH_ADMIN_DASHBOARD.notification.list, element: <AdminNotificationPage /> },
    { path: PATH_ADMIN_DASHBOARD.subscriptions.list, element: <AdminSubscriptionListPage /> },
    { path: PATH_ADMIN_DASHBOARD.dataManager.root, element: <AdminDatabaseManagerPage /> },
  ],
};